import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/contexts/AuthContext";
import { ClipboardCheck, AlertTriangle, CheckCircle2, TrendingUp, ArrowRight, Timer } from "lucide-react";

// Compact one-line onboarding snapshot for the Dashboard. Every tile is a
// deep link to the pipeline board (with the relevant filter pre-applied) so
// leadership can jump from "5 overdue" straight to that filtered view.
export default function OnboardingSnapshot() {
  const [m, setM] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get("/onboarding/metrics")
      .then(({ data }) => setM(data))
      .catch(() => setErr(true));
  }, []);

  if (err) return null;
  const t = m?.totals || {};
  const tiles = [
    { key: "active",    label: "In Pipeline",    value: t.active,             icon: <ClipboardCheck size={12} />, to: "/onboarding", tone: "text-[#0B132B]" },
    { key: "overdue",   label: "Overdue SLA",    value: t.overdue,            icon: <AlertTriangle size={12} />,  to: "/onboarding?overdue=1", tone: (t.overdue || 0) > 0 ? "text-red-600" : "text-[#0B132B]" },
    { key: "signed",    label: "Signed / MTD",   value: t.this_month_signed,  icon: <TrendingUp size={12} />,     to: "/onboarding", tone: "text-[#0B132B]" },
    { key: "installed", label: "Installed / MTD", value: t.this_month_installed, icon: <CheckCircle2 size={12} />, to: "/onboarding", tone: "text-green-700" },
    { key: "lead",      label: "Avg Lead Time",  value: m?.avg_lead_time_days != null ? `${m.avg_lead_time_days}d` : "—", icon: <Timer size={12} />, to: "/onboarding", tone: "text-[#0B132B]" },
  ];

  return (
    <div className="mb-6" data-testid="dashboard-onboarding-snapshot">
      <div className="flex items-center gap-2 mb-2">
        <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-[#D4AF37]">Onboarding</div>
        <Link
          to="/onboarding"
          data-testid="snapshot-open-board"
          className="text-[10px] uppercase tracking-[0.14em] font-bold text-[#0B132B] hover:text-[#D4AF37] inline-flex items-center gap-1"
        >
          Open pipeline <ArrowRight size={10} />
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
        {tiles.map((tile) => (
          <Link
            key={tile.key}
            to={tile.to}
            data-testid={`snapshot-tile-${tile.key}`}
            className="bg-white border border-[#E9ECEF] rounded-sm px-3 py-2 hover:border-[#D4AF37] hover:shadow-sm transition-all flex items-center gap-3"
          >
            <div className="text-[#6C757D]">{tile.icon}</div>
            <div className="flex-1 min-w-0">
              <div className="text-[9px] uppercase tracking-[0.14em] font-bold text-[#6C757D] truncate">{tile.label}</div>
              <div className={`font-display text-xl font-black ${tile.tone} leading-none mt-0.5`}>
                {m == null ? "…" : (tile.value ?? 0)}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
